import React from "react";
import "./ConfigurationEditor.css";
import {ReactComponent as CloseIcon} from "./close.svg";
import authService from "./AuthService";
import toast from "react-hot-toast";
import ReactCodeMirror, {basicSetup, highlightActiveLine} from "@uiw/react-codemirror";
import { langs } from '@uiw/codemirror-extensions-langs';
import {vscodeDark} from "@uiw/codemirror-theme-vscode";

interface ConfigurationEditorProps {
    subject: string
    config: object
    configPutUrl: string
    closeCallback: () => void
}

type ConfigurationEditorState = {
    config: string
}

class ConfigurationEditor extends React.Component<ConfigurationEditorProps, ConfigurationEditorState> {
    constructor(props: ConfigurationEditorProps) {
        super(props);
        this.state = {
            config: JSON.stringify(props.config, null, 4)
        }
    }

    private saveConfiguration = () => {
        fetch(this.props.configPutUrl, {
            method: "PUT",
            headers: [
                ["Accept", "application/json"],
                ["Content-Type", "application/json"],
                ["Authorization", authService.authHeader()]
            ],
            body: this.state.config
        })
            .then(async response => {
                if (response.ok) {
                    toast.success(this.props.subject + " saved")
                } else if (response.status === 404) {
                    const body = await response.json()
                    toast.error("Error 404: "+ body.message)
                } else if (response.status === 400) {
                    const body = await response.json()
                    toast.error("Error 400: " + body.message)
                }
            })
            .catch((error) => {
                console.error(error);
                toast.error("Error saving " + this.props.subject)
            })
            .finally(() => this.props.closeCallback());
    }

    render() {
        return (
            <div className="ConfigurationEditor">
                <div className="ConfigurationEditor-content">
                    <div className="ConfigurationEditor-controls">
                        <div className="ConfigurationEditor-title">Configuration editor</div>
                        <span className="ConfigurationEditor-spacer"/>
                        <button className="ConfigurationEditor-close" onClick={this.props.closeCallback}><CloseIcon/>
                        </button>
                    </div>
                    <div className="ConfigurationEditor-scrollarea">
                        <ReactCodeMirror theme={vscodeDark}
                                         basicSetup={{
                                             highlightActiveLineGutter: false,
                                             highlightActiveLine: false,
                                         }}
                                         extensions={[langs.json()]}
                                         value={this.state.config}
                                         onChange={(value) => this.setState({config: value})}/>
                    </div>
                    <div className=".ConfigurationEditor-buttonbox">
                        <button className="ConfigurationEditor-save" onClick={this.saveConfiguration}>Save</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfigurationEditor;